// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__mytJ-","info":"UpdateTermsInfo_info__23FLj"};